import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalComponent } from 'projects/component-library/components/modal/modal.component';
import { DeleteUsersRequest } from 'projects/shared/services/inspection-companies/inspection-company.user.service';
import { UsersDeletedResponse } from 'projects/shared/services/inspection-companies/models/users/users-deleted-response';
import { ExpectedError, HttpErrorResponse } from 'projects/shared/services/models/error.response';
import { Observable } from 'rxjs';

@Component({
  selector: 'shared-delete-user-confirmation-modal',
  standalone: false,
  template: `
    <mac-modal #modal (close)="closeModal()">
      <mac-modal-title>
        {{ 'Portal.InspectionCompanies.Users.Delete.Title' | translate }}
      </mac-modal-title>

      <mac-modal-content>
        <app-alert type="error" [errorKeys]="errors"></app-alert>

        <div style="padding-top: 16px">
          <p>
            {{ 'Portal.InspectionCompanies.Users.Delete.Confirmation' | translate }} <span style="font-weight: bold"> {{ userEmail }}</span
            >?
          </p>
          <p>{{ 'Portal.InspectionCompanies.Users.Delete.Warning' | translate }}</p>
        </div>
      </mac-modal-content>

      <mac-modal-footer>
        <ng-container *ngIf="errors.length === 0">
          <mac-modal-cancel-button (cancel)="closeModal()" [isDisabled]="isLoading"> </mac-modal-cancel-button>
          <mac-button (click)="onDeleteUser()" [isLoading]="isLoading">
            {{ 'Shared.Modal.DeleteButton.Label' | translate }}
          </mac-button>
        </ng-container>
        <ng-container *ngIf="errors.length > 0">
          <mac-button (click)="closeModal()">
            {{ 'Shared.Modal.OkButton.Label' | translate }}
          </mac-button>
        </ng-container>
      </mac-modal-footer>
    </mac-modal>
  `,
})
export class DeleteUserConfirmationModalComponent {
  @Input() userEmail: string;
  @Input() inspectionCompanyId: number;
  @Input() deleteUsersAction: (model: DeleteUsersRequest) => Observable<UsersDeletedResponse>;

  @Output() userDeleteModalClosed = new EventEmitter<boolean>();

  @ViewChild('modal') modal: ModalComponent;

  isLoading: boolean;
  errors: ExpectedError[] = [];

  closeModal(isDeleted = false): void {
    this.isLoading = false;
    this.errors = [];
    this.modal.closeModal();
    this.userDeleteModalClosed.emit(isDeleted);
  }

  openModal(): void {
    this.modal.openModal();
  }

  onDeleteUser() {
    this.isLoading = true;
    const request = {
      userEmails: [this.userEmail],
    };
    this.deleteUsersAction(request).subscribe({
      next: (response) => {
        this.mapErrors(response);
        if (this.errors.length === 0) {
          this.closeModal(true);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.errors = error.error.errors;
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  private mapErrors(response: UsersDeletedResponse) {
    const deleteUserErrorResponses = response.deleteUserResponses.filter((x) => !x.isDeleted).map((result) => result.error);
    this.errors = Array.from(new Set(deleteUserErrorResponses.flatMap((error) => error.key)));
  }
}
